import { cn } from "@atgis/ui";

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="grid h-8 w-8 place-items-center rounded-lg bg-primary shadow-soft">
        <LogoMark className="h-[18px] w-[18px] text-primary-foreground" />
      </div>
      <div className="leading-none">
        <div className="text-[15px] font-semibold uppercase tracking-[0.22em]">RADGIS</div>
        <div className="mt-0.5 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
          Platform
        </div>
      </div>
    </div>
  );
}

/**
 * Survey target glyph: `[ · ]` — square brackets with center dot,
 * representing a coordinate / waypoint marker.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="miter"
      className={className}
      aria-hidden
    >
      {/* Left bracket [ */}
      <path d="M8 5 H4 V19 H8" />
      {/* Right bracket ] */}
      <path d="M16 5 H20 V19 H16" />
      {/* Center dot */}
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  );
}
